import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const AvatarIcon = (props: IconProps) => (
  <Icon width="32px" height="32px" viewBox="0 0 32 32" {...props}>
    <circle cx="15.61" cy="15.61" r="15.61" fill="#DADADA" />
    <path d="M15.61 15.61c2.3 0 4.163-1.863 4.163-4.163 0-2.3-1.863-4.162-4.163-4.162a4.161 4.161 0 0 0-4.163 4.162c0 2.3 1.863 4.163 4.163 4.163Zm0 2.081c-2.779 0-8.325 1.395-8.325 4.163v2.081h16.65v-2.081c0-2.768-5.547-4.163-8.325-4.163Z" />
  </Icon>
);

export default memo(AvatarIcon);
